var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("skoly-menu", {
        attrs: { profil: _vm.profil },
        on: { updateProfil: _vm.emitUpdateProfil }
      }),
      _vm._v(" "),
      _c(
        "main",
        {
          staticClass:
            "profileDashboard skolska-sekcia-main justify-content-center"
        },
        [
          _c("article", [
            _c(
              "aside",
              { staticClass: "rounded-10 bg-white position-relative p-50" },
              [
                _c("h3", [_vm._v("Žiaci v našej triede")]),
                _vm._v(" "),
                _c(
                  "form",
                  {
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.addZiak($event)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "form-row" }, [
                      _c("div", { staticClass: "col-12 col-md-12" }, [
                        _c(
                          "div",
                          { staticClass: "position-relative ziak-input-group" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.novyZiak,
                                  expression: "novyZiak"
                                }
                              ],
                              staticClass: "form-control form-control-lg",
                              attrs: {
                                type: "text",
                                name: "pridat-ziaka",
                                id: "pridat-ziaka",
                                placeholder:
                                  "Pridajte žiaka do triedy, napíšte meno ..."
                              },
                              domProps: { value: _vm.novyZiak },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.novyZiak = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn --secondary",
                                attrs: { type: "submit" }
                              },
                              [_vm._v("pridať žiaka")]
                            )
                          ]
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "ziaci hover-delete" },
                  _vm._l(_vm.zoznamZiakov, function(ziak, index) {
                    return _c("li", { key: index }, [
                      _c("span", {
                        staticClass: "icon icon--user mr-10 text-icon"
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "icon icon--delete mr-10 text-primary",
                        on: {
                          click: function($event) {
                            return _vm.removeZiak(index)
                          }
                        }
                      }),
                      _vm._v(
                        "\n                            " +
                          _vm._s(ziak) +
                          "\n                        "
                      )
                    ])
                  }),
                  0
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("aside", [
            _c("div", { staticClass: "m-skolskaKarta mb-50" }, [
              _c("h5", { staticClass: "a-skolskaKarta__title" }, [
                _vm._v("žiakov v našej triede")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-between"
                },
                [
                  _c(
                    "div",
                    { staticClass: "a-skolskaKarta__value text-primary" },
                    [_vm._v(_vm._s(_vm.zoznamZiakov.length))]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _vm._m(1)
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "d-flex align-items-center justify-content-between mb-20"
      },
      [
        _c("p", { staticClass: "mb-0 text-uppercase" }, [
          _c("b", { staticClass: "text-dark" }, [_vm._v("zoznam žiakov")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pl-50 pr-50" }, [
      _c("span", { staticClass: "icon icon--info text-icon mb-20 text-21" }),
      _vm._v(" "),
      _c("p", { staticClass: "line-24" }, [
        _vm._v(
          "V tejto sekcii pani učiteľka/pán učiteľ pridá krstné mená všetkých detí zo svojej triedy. V niektorých tvorivých úlohách počet žiakov určuje, kedy je úloha splnená na 100% - napríklad pre triedu, v ktorej je 15 detí pani učiteľka/pán učiteľ zadá 15 mien a 100% splnenú úlohu bude mať kolektív keď do vypracovania úlohy nahrá 15 obrázkov."
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }